// extracted by mini-css-extract-plugin
export default {"container":"GameIcon_container__Dy6Oa","gameIcon":"GameIcon_gameIcon__9+jS4"};